import React from 'react';
import { IProps, IState } from './types';
import PolicyInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PolicyInfo';
import VehicalInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/VehicalInfo';
import InsuredContent from 'components/MemberCenter/PolicyInquiry/PolicyDetail/InsuredContent';
import PolicyholderInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PolicyholderInfo';
import InsuredInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/InsuredInfo';
import PaymentInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PaymentInfo';
import { RouterSettings } from 'constants/models/routerSettings';
import { DetailVehicleContent, InsuredDataVehicleContentInfo } from 'bff/models/member';
import _ from 'lodash';
import commonService from 'utils/commonService';
import { connect } from 'react-redux';
import { RootReducersState } from 'redux/reducers';

class PolicyDetailVehicle extends React.Component<IProps, IState> {
  state: IState = {
    detailInfo: {
      APPLICANT_DATA: {
        ADDRESS: {
          ADDRESS: '',
          AREA_ID: '',
          CITY_ID: '',
          FULL: '',
          POST_CODE: ''
        },
        BIRTHDAY: '',
        EMAIL: '',
        GENDER: '',
        ID: '',
        MARRIAGE: '',
        MOBILE: '',
        NAME: '',
        NATIVE: ''
      },
      AVAILABLE_ACTION: {
        ACTIONS: new Array(0),
        ACTION_URL: ''
      },
      INSURED_DATA: {
        DATA: new Array(0)
      },
      PAYMENT_DATA: {
        AMOUNT: 0,
        APPROVE_CODE: '',
        BANK: '',
        BANK_ACCOUNT: '',
        CARD_NO: '',
        PAYER_ID: '',
        PAYER_NAME: '',
        PAY_BY: '',
        TRANSACTION: ''
      },
      POLICY_DATA: {
        APPLY_NO: '',
        APPLY_TIME: '',
        BC_TYPE: '',
        CONFLICT_STATUS: '',
        DEPARTMENT: '',
        OPERATOR: '',
        PAYMENT_STATUS: '',
        POLICY_DELIVERY: '',
        POLICY_NO: '',
        POLICY_STATUS: '',
        PROGRAM_ID: ''
      },
      POLICY_INFO: {
        INS_PERIOD: {
          COMPULSORY_DATE: '',
          VOLUNTARY_DATE: ''
        },
        PARAM_TEXT: '',
        COMPULSORY_DISCOUNT: 0,
        TOTAL_FEE: 0,
        TOTAL_FEE_DISCOUNT: 0,
        detailInsData: new Array(0),
        INS_ANUAL: ''
      },
      RENEWAL_INFO: {
        COMPULSORY_NO: '',
        POLICY_NO: ''
      },
      VEHICLE_DATA: {
        CAR_LICENSE: '',
        CAR_TYPE: '',
        DISPLACEMENT: 0,
        DISPLACEMENT_UNIT: '',
        ENGINE_ID: '',
        ISSUE_DATE: '',
        MANUFACTURE: '',
        MANUFACTURE_TEXT: '',
        VEHICLECAT_ID: '',
        VEHICLE_ID: '',
        VEHICLENAME: ''
      },
      OPERATION_LOG: new Array(0)
    },
    insTypeId: ''
  }

  private insType = this.props.route && this.props.route.insType;

  componentDidMount () {
    let detailInfoVal;
    let insTypeIdVal;
    if (this.props.history.location.state) {
      // 透過路由取得險種類別
      const { detailInfo, insTypeId }: any = this.props.history.location.state;
      detailInfoVal = detailInfo;
      insTypeIdVal = insTypeId;
    }
    // console.log('detailInfoVal', detailInfoVal);
    if (!detailInfoVal || !insTypeIdVal) {
      this.props.history.replace(RouterSettings.MemberCenter.PolicyInquiry);
      return;
    }

    this.setState({
      detailInfo: { ...detailInfoVal },
      insTypeId: insTypeIdVal
    });
  }

  render () {
    const { POLICY_DATA, VEHICLE_DATA, POLICY_INFO, APPLICANT_DATA, INSURED_DATA, PAYMENT_DATA } = this.state.detailInfo;
    return (
      <div className={`policy-detail policy-detail--${this.insType}`}>
        <div className="template-container">
          <div className="template-content">
            <div className="policy-detail__content">
              {/* 保單資訊 */}
              {
                POLICY_DATA && (
                  <PolicyInfo {...POLICY_DATA} />
                )
              }
              {/* 車籍資料 */}
              {
                VEHICLE_DATA && (
                  <VehicalInfo {...VEHICLE_DATA} />
                )
              }
              {/* 投保内容 */}
              {
                POLICY_INFO && (
                  <InsuredContent collapsible>
                    <InsuredContent.List
                      INS_TYPE_ID={this.state.insTypeId}
                      COMPULSORY_DATE={POLICY_INFO.INS_PERIOD.COMPULSORY_DATE}
                      VOLUNTARY_DATE={POLICY_INFO.INS_PERIOD.VOLUNTARY_DATE}
                      INS_ANUAL={POLICY_INFO.INS_ANUAL}
                    />
                    <InsuredContent.Table
                      INS_TYPE_ID={this.state.insTypeId}
                      TOTAL_FEE={commonService.thousandFormat(`${POLICY_INFO.TOTAL_FEE_DISCOUNT}`)}
                      DATA={POLICY_INFO.detailInsData && [
                        {
                          CHILD_DATA: _.map(POLICY_INFO.detailInsData, (content: DetailVehicleContent) => {
                            return {
                              ITEM_NAME: content.ITEM_CONTENT,
                              ITEM_AMT: content.ITEM_OPTION,
                              DISCOUNT_AMT: content.FEE_AFTER_DISCOUNT
                            };
                          })
                        }
                      ]}
                    />
                  </InsuredContent>
                )
              }
              {/* 要保人資料 */}
              {
                APPLICANT_DATA && (
                  <PolicyholderInfo {...APPLICANT_DATA} ADDRESS={APPLICANT_DATA.ADDRESS.FULL} />
                )
              }

              {/* 被保險人資料 */}
              <InsuredInfo
                InsTypeId={this.state.insTypeId}
                DATA={INSURED_DATA.DATA && _.map(INSURED_DATA.DATA, (data: InsuredDataVehicleContentInfo) => {
                  return {
                    BIRTHDAY: data.INSURED_BIRTHDAY,
                    NAME: data.NAME,
                    ID: data.ID,
                    GENDER: data.GENDER,
                    NATIONALITY_TYPE: data.INSURED_ID_TYPE,
                    MOBILE: data.INSURED_MOBILE,
                    ADDRESS: data.ADDRESS.FULL,
                    VEHICLE_ADDRESS: data.ADDRESS,
                    MARRIAGE: data.MARRIAGE,
                    MARRIAGE_TEXT: data.MARRIAGE_TEXT,
                    EMAIL_ADDR: data.INSURED_EMAIL,
                    INSURED_ID_TYPE_TEXT: data.INSURED_ID_TYPE_TEXT
                  };
                })}
              />
              {/* 付款資訊 */}
              <PaymentInfo {...PAYMENT_DATA} />
            </div>
            <div className="policy-detail__controls">
              <button type="button" className="policy-detail__btn" onClick={() => this.props.history.push(RouterSettings.MemberCenter.PolicyInquiry)}>{commonService.getNameByLng(this.props.resources, 'TID_Back_to_policy_query')}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => {
  return {
    resources: state.resources
  };
};

export default connect(mapStateToProps)(PolicyDetailVehicle);
